import { cva } from "class-variance-authority";
import React from "react";

import { cn } from "@/lib/chillnn/cn";

import type { VariantProps } from "class-variance-authority";

const svgIconVariants = cva("", {
	variants: {
		svgColor: {
			default: "text-current",
		},
		size: {
			default: "h-6 w-6",
			sm: "h-5 w-5",
			xs: "h-4 w-4 p-1",
			md: "h-7 w-7",
			lg: "h-8 w-8",
		},
	},
	defaultVariants: {
		svgColor: "default",
		size: "default",
	},
});

export type SVGIconProps = { className?: string } & VariantProps<typeof svgIconVariants>;

interface IconCreatorProps extends React.SVGProps<SVGSVGElement>, VariantProps<typeof svgIconVariants> {
	svgIcon: React.FunctionComponent<
		React.SVGProps<SVGSVGElement> & {
			title?: string | undefined;
		}
	>;
	className?: string;
}

export const IconCreator = (props: IconCreatorProps) => {
	const { svgIcon: Icon, className, svgColor, size } = props;

	return <Icon className={cn(svgIconVariants({ svgColor, size }), className)} />;
};
